import * as Yup from 'yup';

const residenceSchema = Yup.object().shape({
  address: Yup.string().required('address_required'),
  zip: Yup.string().required('zip_required'),
  country: Yup.string().required('country_required'),
  city: Yup.string().required('city_required'),
});

const phoneSchema = Yup.object().shape({
  phoneType: Yup.string().required('phone_type_required'),
  phoneNumber: Yup.string().required('phone_number_required'),
});

const emailSchema = Yup.object().shape({
  emailType: Yup.string().required('email_type_required'),
  emailAddress: Yup.string().required('email_address_required'),
});

const comsSchema = Yup.object().shape({
  phoneNumbers: Yup.array(phoneSchema)
    .required('phone_number_required')
    .min(1, 'phone_number_required'),
  emailAddresses: Yup.array(emailSchema)
    .required('email_address_required')
    .min(1, 'email_address_required'),
});

export const validationSchema = Yup.object().shape({
  preferredGivenName: Yup.string().required('first_name_required'),
  preferredFamilyName: Yup.string().required('last_name_required'),
  nickname: Yup.string().notRequired(),
  birthDate: Yup.date().required('date_of_birth_required'),
  nationalityCode: Yup.string().required('nationality_required'),
  residence: residenceSchema.required(),
  coms: comsSchema.required(),
});
